let appContent = null; 

export const setContent = (data) => {
    appContent = data; 
};

export const getContent = (filterKeyPrefix = null, langCode = null) => {
    if (!appContent) {
        console.log('Content not loaded yet.');
        return null;
    }
   
    let result = appContent;

    if (langCode && result.hasOwnProperty(langCode)) {
        result = { [langCode]: { ...result[langCode] } };
    } else if (langCode && !result.hasOwnProperty(langCode)) {
        return { [langCode]: {} };
    }
  
    if (!filterKeyPrefix) {
        return result; 
    }

    return Object.keys(result).reduce((acc, lang) => {
        const langLabels = result[lang];
   
        const filteredLangLabels = Object.keys(langLabels).reduce((innerAcc, key) => {
            if (key.startsWith(filterKeyPrefix)) {
                innerAcc[key] = langLabels[key];
            }
            return innerAcc;
        }, {});
   
        acc[lang] = filteredLangLabels;
        return acc;
    }, {});
};